export default angular
  .module("CommentsCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("CommentsController", [
    "$scope",
    "$rootScope",
    "$timeout",
    "$location",
    "$stateParams",
    "$anchorScroll",
    "Scripts",
    "Message",
    "modal",
    "Aliases",
    "Flash",
    function (
      $scope,
      $rootScope,
      $timeout,
      $location,
      $stateParams,
      $anchorScroll,
      Scripts,
      Message,
      modal,
      Aliases,
      Flash,
    ) {
      $scope.sortMessages = [];
      $scope.sortMessages.column = "TIME_STAMP";
      $scope.sortMessages.direction = true; // descending direction
      $scope.messagePageSize = 20;
      $scope.selectedMessageItem = undefined;
      $scope.loggedUserId = $rootScope.loggedUser.id;
      $scope.isScript = !!$stateParams.scriptid;

      $scope.selectedMessageIsLinkedToScript = undefined;
      $scope.selectedMessageIsLinkedToAlias = undefined;

      $scope.resourceId = {
        script: "SCRIPT_ID",
        alias: "ALIAS_ID",
      };
      $scope.resourceName = {
        script: "SCRIPT_NAME",
        alias: "ALIAS_NAME",
      };

      let loadedLinkedScriptMeta = {};
      [$scope.RESOURCE_ID, $scope.RESOURCE_NAME] = $stateParams.scriptid ? ["SCRIPT_ID", "SCRIPT_NAME"] : ["ALIAS_ID", "ALIAS_NAME"];
      const resourceId = $stateParams.scriptid ? $stateParams.scriptid : $stateParams.id;

      (() => {
        if ($scope.isScript) {
          Scripts.loadScriptMetaByID(resourceId, (data) => {
            loadedLinkedScriptMeta = data;
          });
        } else if (resourceId) {
          Aliases.loadAliasById(resourceId, (data) => {
            loadedLinkedScriptMeta.TITLE = data.DEF;
          });
        }
      })();

      // Sets table sort according to COLUMN
      // Also toggles between ascending and descending
      $scope.changeSortingMessages = function (column) {
        if ($scope.sortMessages.column === column) {
          $scope.sortMessages.direction = !$scope.sortMessages.direction;
        } else {
          $scope.sortMessages.column = column;
          $scope.sortMessages.direction = false;
        }
      };

      const getNewMessageItem = type => ({
        SENDER_ID: $scope.loggedUserId,
        USER_FULL_NAME: $rootScope.loggedUser.fullname,
        MESSAGE: "",
        TYPE: type,
        PRIORITY: "Normal",
        [$scope.RESOURCE_ID]: resourceId,
        [$scope.RESOURCE_NAME]: loadedLinkedScriptMeta.TITLE,
        TITLE: "",
        TO_USER: [],
        ASSIGNED_TO_USER: {},
        isNewMessageItem: true,
        removableReceiverList: [],
      });

      const scrollToMessageItemForm = () => {
        $location.hash("selected-item-form");
        $anchorScroll();
      };

      const confirmExitingFromModifiedSelectedMessageItem = () =>
        modal.createConfirmationModal(
          `Unsaved ${$scope.selectedMessageItem.TYPE}`,
          `${$scope.selectedMessageItem.TYPE} is modified but not saved. Are you sure you want to leave?`,
        );

      const loadMessageItem = (messageItemId) => {
        Message.loadMessageWithID(messageItemId, (dataArray) => {
          const retrievedMessageItem = dataArray[0];
          retrievedMessageItem.removableReceiverList = [];
          Message.loadMessageReceiver(retrievedMessageItem.ID, (result) => {
            retrievedMessageItem.TO_USER = result;
            $scope.isAddressedToTheLoggedUser = result
              .find(el => el.TO_USER_ID === $scope.loggedUserId) !== undefined;
            if (retrievedMessageItem.ASSIGNED === 1) {
              retrievedMessageItem.ASSIGNED_TO_USER = result.filter(el => el.ASSIGNED === 1)[0];
            }
          });
          $scope.selectedMessageItem = retrievedMessageItem;
          $scope.selectedMessageIsLinkedToScript = !!$scope.selectedMessageItem.SCRIPT_ID;
          $scope.selectedMessageIsLinkedToAlias = !!$scope.selectedMessageItem.ALIAS_ID;
          $scope.messageItemForm.$setPristine();
          scrollToMessageItemForm();
        });
      };

      const setNewMessageItem = (type) => {
        $scope.selectedMessageItem = getNewMessageItem(type);
        $scope.selectedMessageIsLinkedToScript = !!$scope.selectedMessageItem.SCRIPT_ID;
        $scope.selectedMessageIsLinkedToAlias = !!$scope.selectedMessageItem.ALIAS_ID;

        scrollToMessageItemForm();
      };

      const createOrLoadMessageItem = (current, call) => {
        const { $pristine, $submitted } = $scope.messageItemForm;
        if (!$pristine && !$submitted) {
          confirmExitingFromModifiedSelectedMessageItem()
            .result
            .then(({ action }) => {
              if (action === "confirm") {
                call();
              }
            });
        } else {
          call();
        }
      };

      $scope.loadSelectedMessageItem = messageItemId =>
        createOrLoadMessageItem(
          $scope.selectedMessageItem,
          () => loadMessageItem(messageItemId),
        );

      $scope.createAnewMessageItem = (type) => {
        createOrLoadMessageItem(
          $scope.selectedMessageItem,
          () => setNewMessageItem(type),
        );
      };

      $scope.addUserToMessageItem = selectedMessageItem =>
        modal.createModal(
          "editSendTo",
          "ModifySendToController",
          {
            selectedMessageItem: () => selectedMessageItem,
            isNewMessageItem: () => true,
          },
        ).result.then(({ action, payload }) => {
          if (action === "add") {
            $scope.selectedMessageItem.TO_USER = payload.sendTo;
            $scope.selectedMessageItem.removableReceiverList = payload.removableReceiverList;
          }
        });

      $scope.linkMessageItemToScriptModal = (messageItemId, linkedResourceId, kind) =>
        modal.createModal(
          "editLinkToScript",
          "ModifyLinkToScriptController",
          {
            messageItemId: () => messageItemId,
            resourceId: () => linkedResourceId,
            resourceKind: () => kind,
            currentLink: () => ({
              ID: $scope.selectedMessageItem[$scope.resourceId[kind]],
              TITLE: $scope.selectedMessageItem.TITLE,
            }),
          },
        ).result.then(({ action, payload }) => {
          if (action !== "cancel") {
            $scope.selectedMessageItem[$scope.resourceId[kind]] = payload.ID || null;
            $scope.selectedMessageItem[$scope.resourceName[kind]] = payload.TITLE || null;
            $scope.selectedMessageItem.TITLE = payload.TITLE;

            $scope.selectedMessageIsLinkedToScript = !!$scope.selectedMessageItem.SCRIPT_ID;
            $scope.selectedMessageIsLinkedToAlias = !!$scope.selectedMessageItem.ALIAS_ID;
          }
        });

      // Assign task modal window
      $scope.assignMessageItemTaskModal = (messageItemId, assignedId) =>
        modal.createModal(
          "editAssignedTo",
          "ModifyAssignedToController",
          {
            messageItemId: () => messageItemId,
            assignedId: () => assignedId,
            isNewMessageItem: () => true,
          },
        ).result.then(({ action, payload }) => {
          if (action === "save") {
            $scope.selectedMessageItem.ASSIGNED_TO_USER = payload;
          }
          $scope.$emit("loadScriptMessage", resourceId);
        });

      $scope.sendMessageItem = () => {
        const { message } = $scope.messageItemForm;
        if ((message.$viewValue || "").trim().length > 0) {
          const saveOrUpdate = $scope.selectedMessageItem.isNewMessageItem
            ? Message.createMessageItem
            : Message.updateMessage;

          saveOrUpdate($scope.selectedMessageItem, (data) => {
            const messageItemId = data.id;
            if ($scope.selectedMessageItem.TYPE === "Task" && $scope.selectedMessageItem.ASSIGNED_TO_USER) {
              $scope.selectedMessageItem.ASSIGNED_TO_USER.MESSAGE_ID = messageItemId;
              Message.updateAssigned($scope.selectedMessageItem.ASSIGNED_TO_USER, () =>
                $scope.loadSelectedMessageItem(messageItemId));
            } else {
              $scope.loadSelectedMessageItem(messageItemId);
            }
            $scope.$emit("loadScriptMessage", resourceId);
          });
        } else {
          Flash.create("danger", "Message can't be empty", "basicAlert");
        }
      };
    },
  ]);
